import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { WrapperSectionHome } from '../../../../components/WrapperSectionHome';
import styles from './SectionBlog.module.css';

const SectionBlog = () => {
  const data = useStaticQuery(graphql`
    query BlogPostsQuery {
      allAutoscarBlogPost(sort: { fields: data, order: DESC }) {
        nodes {
          id
          link
          title
          description
          imagem
          categoria
          data
        }
      }
    }
  `);

  const posts = data.allAutoscarBlogPost.nodes;

  return (
    <div style={{ marginBottom: '32px' }}>
      <WrapperSectionHome
        initialText="Confira nosso"
        bolderText="BLOG"
        textLinkTo="Ver todas postagens"
        linkTo="https://blog.autoscar.com.br/"
        linkAria="Ir para as postagens do blog"
        home
      >
        <section className={styles.sectionBlog}>
          <div className={styles.gridContainer}>
            {posts.map((post, idx) => (
              <div className={styles.card} key={post.id}>
                <a href={post.link} target="_blank" rel="noreferrer">
                  <div className={styles.imageWrapper}>
                    {post.imagem ? (
                      <img className={styles.imagePlaceholder} src={post.imagem} alt={post.title} />
                    ) : (
                      <div className={styles.imagePlaceholder}>Imagem</div>
                    )}
                    <div className={styles.category}>{post.categoria}</div>
                  </div>
                </a>
                <div className={styles.meta} />

                <h3 className={styles.title}>
                  <a className={styles.atitle} href={post.link} target="_blank" rel="noreferrer">
                    {post.title}
                  </a>
                </h3>
                <p
                  className={styles.description}
                  dangerouslySetInnerHTML={{ __html: post.description }}
                />
                <a
                  className={styles.readMore}
                  href={post.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ler completo &gt;
                </a>
              </div>
            ))}
          </div>
        </section>
      </WrapperSectionHome>
    </div>
  );
};

export { SectionBlog };
